import {makeReactContext} from 'lib/makeReactContext';
import {Schema} from 'schemas/SchemaConstants';

interface LookupConfigContextInterface {
  baseSchema: Schema | null;
}

export const LookupConfigContext = makeReactContext<LookupConfigContextInterface>(
  () => ({
    baseSchema: null,
  }),
  'LookupConfigContext'
);
